module.exports = __webpack_public_path__ + "static/media/gravewalkers-red.2c579207.png";